module.exports = __webpack_public_path__ + "static/flags/ZI-ef911776275ca1558f848e81bd0d7e7d.gif";